import { useEffect, useState } from 'react'
import useManagerStore from '../store/managerStore'
import { getTenantInfo } from '../api/products'
import { normalizeVertical } from '../utils/verticals'

// Module-level cache so every consumer (nav shell, BookingsPage, …) shares
// one lookup per tenant per session instead of refetching.
const verticalCache = new Map()

// Returns the tenant's canonical vertical ('fnb' | 'spa' | 'hotel' |
// 'education' | 'retail' | 'other'). Defaults to 'fnb' while loading and on
// error, which preserves today's F&B-shaped UI as the safe fallback.
export default function useTenantVertical() {
    const tenantId = useManagerStore((s) => s.tenantId)
    const [, forceRender] = useState(0)

    useEffect(() => {
        if (!tenantId || verticalCache.has(tenantId)) return undefined
        let alive = true
        getTenantInfo(tenantId)
            .then((d) => {
                verticalCache.set(
                    tenantId,
                    normalizeVertical(d?.industry_type || d?.type, 'fnb'),
                )
            })
            .catch(() => {
                verticalCache.set(tenantId, 'fnb')
            })
            .finally(() => {
                if (alive) forceRender((n) => n + 1)
            })
        return () => {
            alive = false
        }
    }, [tenantId])

    return (tenantId && verticalCache.get(tenantId)) || 'fnb'
}
